/**
 * @see https://github.com/ggolikov/Leaflet.River
 */
let {
  FeatureGroup,
  setOptions,
  polyline: toPolyline
} = L;
let FeatureGroupPrototype = FeatureGroup.prototype;
/**
 * 性能太差，有待优化
 */
export default FeatureGroup.extend({
  options: {
    color: 'blue',
    minWidth: 1,
    maxWidth: 10,
    ratio: null
  },

  initialize(latLngs, options) {
    FeatureGroupPrototype.initialize.call(this, [], options);
    this._latLngs = latLngs;

    setOptions(this, options);
    this._buildLines(latLngs);
  },

  onAdd(map) {
    FeatureGroupPrototype.onAdd.call(this, map);
    this._getLength(map);
    this.setStyle();
  },

  _buildLines(latLngs) {
    for (var i = 0; i < latLngs.length - 1; i++) {
      var line = toPolyline([latLngs[i], latLngs[i + 1]]);
      this.addLayer(line);
    }
  },

  _getLength(map) {
    var latLngs = this._latLngs,
      totalLength = 0;

    for (var i = 0; i < latLngs.length - 1; i++) {
      totalLength += map.latLngToLayerPoint(latLngs[i]).distanceTo(map.latLngToLayerPoint(latLngs[i + 1]));
    }

    return this._length = totalLength;
  },

  /**
   * 
   */
  setStyle(style) {
    var opt = this.options = L.extend(this.options, style),
      totalLength = this._length,
      map = this._map,
      layers = this._layers,
      length = 0,
      layer, latLngs;

    for (var key in layers) {
      layer = layers[key];
      latLngs = layer.getLatLngs();
      length += map.latLngToLayerPoint(latLngs[0]).distanceTo(map.latLngToLayerPoint(latLngs[1]));
      layer.setStyle(L.extend({}, opt, {
        weight: opt.ratio ? length / opt.ratio : opt.minWidth + (opt.maxWidth - opt.minWidth) * (length / totalLength)
      }));
    }
  },

  setMinWidth(width) {
    this.setStyle({
      minWidth: width
    })
  },

  setMaxWidth(width) {
    this.setStyle({
      maxWidth: width
    })
  },

  getMinWidth() {
    return this.options.minWidth;
  },

  getMaxWidth() {
    return this.options.maxWidth;
  },

  useLength(ratio) {
    setOptions(this, {
      ratio: ratio
    });
    return this;
  },

  convertToPolyline(options) {
    return toPolyline(this._latLngs, options);
  }
});



// WEBPACK FOOTER //
// ./src/feature/River.js